import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-souscription',
  templateUrl: './souscription.component.html',
  styleUrls: ['./souscription.component.scss']
})
export class SouscriptionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
